const trustedDomains = ['epicurosaas.com', 'epicurotesting.com'];
const trustedLocalHosts = ['localhost', '127.0.0.1'];

interface WindowLocation {
  hostname: string;
}

interface WindowLike {
  location: WindowLocation;
}

export function isTrustedOrigin(origin: string, win?: WindowLike): boolean {
  if (!origin) {
    return false;
  }

  try {
    const originHostname = new URL(origin).hostname;

    let currentHostname: string | undefined;
    if (win) {
      currentHostname = win.location.hostname;
    } else if (typeof globalThis !== 'undefined' && 'location' in globalThis) {
      currentHostname = (globalThis as unknown as WindowLike).location.hostname;
    }

    if (!currentHostname) {
      return false;
    }

    if (originHostname === currentHostname) {
      return true;
    }

    if (trustedLocalHosts.includes(originHostname)) {
      return true;
    }

    return trustedDomains.some(
      (domain) =>
        originHostname === domain || originHostname.endsWith(`.${domain}`),
    );
  } catch {
    return false;
  }
}
